import axios from 'axios';
import { FC, useState } from 'react';
import { Env } from '../../../env';
import { RawMessage } from '../../../types/channel';
import { relevanceFuniction } from '../../../utils/boxShadov';
import Colors from '../../../utils/colors';
import { DocumentIcon, DownloadIcon } from '../../../utils/icons';
import CircleProgress from '../CircleProgress';
import styles from './index.module.css';
import STR_N from '../../../utils/StringLength';

interface Props {
    message: RawMessage;
    status: 'Play' | 'Download' | 'View';
    downloadFile?: () => void;
    loading: boolean;
    mediaLocation?: string;
    deleteReportMessage?: () => void;
    mediaTitle?: string;
    inList?: boolean;
}

const MessageDoc: FC<Props> = ({ message, mediaLocation, mediaTitle, inList }) => {
    const [percentCompleted, setPercentCompleted] = useState<any>(0);

    const filename = mediaTitle ?? '';

    const MESSAGE_STYLE = relevanceFuniction(message);
    const textSize = MESSAGE_STYLE?.fontSize;

    const handleClickDownloader = async () => {
        await axios({
            url: `${Env.AssetsUrl}/${mediaLocation}`,
            method: 'GET',
            responseType: 'blob', // important
            onDownloadProgress: progressEvent => {
                setPercentCompleted(Math.round((progressEvent.loaded * 100) / progressEvent.total!)); // you can use this to show user percentage of file downloaded
            },
        })
            .then(response => {
                console.log(response, 'response');

                const url = window.URL.createObjectURL(
                    new Blob([response.data], {
                        type: response.headers['content-type'],
                    }),
                );
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', filename);
                document.body.appendChild(link);
                link.click();
            })
            .catch(error => {
                console.log('Errore: ' + error.message);
                return [];
            });
    };

    const changeIcons = () => {
        if (percentCompleted === 0) {
            return <DownloadIcon />;
        } else if (percentCompleted === 100) {
            return <DocumentIcon />;
        } else {
            return <CircleProgress progress={percentCompleted} />;
        }
    };

    return (
        <div className={inList ? styles.listDoc : styles.ownCard} onClick={() => handleClickDownloader()}>
            <div className={styles.ondownloadCard} style={{ backgroundColor: Colors.YellowOrange }}>
                {changeIcons()}
            </div>
            <div className={styles.fileInfo}>
                <span
                    style={{
                        fontSize: textSize,
                        fontFamily: 'Montserrat',
                        fontWeight: 500,
                    }}
                >
                    {STR_N.userNameLeng(mediaTitle ?? '', 20)}
                </span>
                <span
                    style={{
                        fontSize: 10,
                        fontFamily: 'Montserrat',
                        fontWeight: 400,
                    }}
                >
                    100kb
                </span>
            </div>
        </div>
    );
};

export default MessageDoc;
